import { createSlice } from '@reduxjs/toolkit';
import { IAction } from '../store';
import { ActionName } from '../../components/General/DocTable/DocTableActions';

export interface ActionHandlingState {
    actions: ActionName[];
}

const initialState: ActionHandlingState = {
    actions: [],
};

const reducers = {
    setActions(state: ActionHandlingState, action: IAction<ActionName[]>) {
        state.actions = action.payload;
    },
    registerAction(state: ActionHandlingState, action: IAction<ActionName[]>) {
        const actions = action.payload;
        if (actions.every(action => state.actions.includes(action))) return;

        state.actions = Array.from(new Set([...state.actions, ...actions]));
    },
    releaseAction(state: ActionHandlingState, action: IAction<ActionName[]>) {
        const actions = action.payload;
        if (actions.every(action => !state.actions.includes(action))) return;

        state.actions = state.actions.filter(action => !actions.includes(action));
    },
};

export const actionHandlingSlice = createSlice({
    name: 'actionHandling',
    initialState,
    reducers,
});

export const { setActions, registerAction, releaseAction } = actionHandlingSlice.actions;

export default actionHandlingSlice.reducer;
